export default __webpack_public_path__ + "static/media/about--tablet.20c28439.jpg";